import { useCallback } from "react"

import { boolToOnOff, onOffToBool } from "../modules/app-settings"

interface UseToggleSettingsOptions {
  /**
   * Current value of the setting (ON or OFF)
   */
  currentValue: OnOff
  /**
   * Function to update the setting value
   */
  setValue: (value: OnOff)=> void
}

/**
 * Custom hook for managing ON/OFF toggle settings with consistent behavior
 * Provides a toggle function that switches between ON and OFF states
 */
export function useToggleSettings({
  currentValue,
  setValue,
}: UseToggleSettingsOptions) {
  const toggle = useCallback(()=> {
    setValue(boolToOnOff(!onOffToBool(currentValue)))
  }, [currentValue, setValue])

  const isOn = onOffToBool(currentValue)
  const isOff = !isOn

  return {
    /** Current value as boolean (true for OFF, false for ON) */
    isOff,
    /** Current value as boolean (true for ON, false for OFF) */
    isOn,
    /** Function to toggle between ON and OFF */
    toggle,
    /** Current raw value (ON or OFF string) */
    value: currentValue,
  }
}
